export type FetchXmlErrorCode =
  | "invalid-root"
  | "unknown-element"
  | "unknown-attribute"
  | "invalid-child"
  | "missing-required-attribute"
  | "invalid-attribute-value"
  | "parse-error"
  | "invalid-shape";

export class FetchXmlError extends Error {
  code: FetchXmlErrorCode;
  path: string;

  constructor(code: FetchXmlErrorCode, message: string, path = "") {
    super(message);
    this.code = code;
    this.path = path;
  }
}
